import { render } from "./Tos.vue?vue&type=template&id=3b1ae13e&scoped=true"
import script from "./Tos.vue?vue&type=script&lang=js"
export * from "./Tos.vue?vue&type=script&lang=js"

import "./Tos.vue?vue&type=style&index=0&id=3b1ae13e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1ae13e"]])

export default __exports__